import { render, staticRenderFns } from "./indexAbout.vue?vue&type=template&id=5108147f&scoped=true"
import script from "./indexAbout.vue?vue&type=script&lang=js"
export * from "./indexAbout.vue?vue&type=script&lang=js"
import style1 from "./indexAbout.vue?vue&type=style&index=1&id=5108147f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108147f",
  null
  
)

export default component.exports